import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import { updatePageURLWithQuery } from 'src/redux/products/thunks/updatePageURLWithQuery';
import { TriggerName } from 'src/redux/products/types';
import { selectActiveFacets } from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import { scrollToTopOfProductsList } from 'src/utils/scrollToTopOfProductsList';
import type { ChangedFacetDetails } from '../ListingsControlsOptions/types';
import { ActiveFacets } from './ActiveFacets';

export const ActiveFacetsContainer = () => {
  const state = useSelector((state: ReduxApplicationState) => state);
  const dispatch = useDispatch<AppThunkDispatch>();
  const activeFacets = selectActiveFacets(state);

  const resetFacetOption = (changedFacet: ChangedFacetDetails) => {
    const changedOption = changedFacet.options[0];

    batch(() => {
      dispatch(actions.changeFacetOption(changedFacet));
      dispatch(
        requestProducts({
          triggerName: TriggerName.RESET_FACET,
          metadata: {
            facetTitle: changedFacet.title,
            optionTitle: changedOption.title!,
            optionActive: changedOption.active,
          },
        }),
      );
      dispatch(updatePageURLWithQuery());
    });

    scrollToTopOfProductsList();
  };

  const resetAllFacets = () => {
    batch(() => {
      dispatch(actions.resetFacets());
      dispatch(requestProducts({ triggerName: TriggerName.RESET_ALL_FACETS_AND_SORT }));
      dispatch(updatePageURLWithQuery());
    });

    scrollToTopOfProductsList();
  };

  return (
    <ActiveFacets
      activeFacets={activeFacets}
      onResetFacet={resetFacetOption}
      onResetFacets={resetAllFacets}
    />
  );
};
